export const dataJuegoCerebro = [
  {
    num: 1,
    pregunta: `Tenés una reunión con tus amigos/as el fin de semana, ¿te ocupas vos de que la ropa que vas a usar esté en condiciones? `,
    respuesta: `true`,
    perfil: [`a`, "b", "c", "d", "e"],
  },
  {
    num: 2,
    pregunta: `¿Esperás a que alguien te dé indicaciones o te lo pida para hacer tareas del hogar?`,
    respuesta: `false`,
    perfil: [`a`, "b", "d", "e"],
  },
  {
    num: 3,
    pregunta: `¿Hay alguna tarea de la casa que sea tu responsabilidad?`,
    respuesta: `true`,
    perfil: [`a`, "b", "d", "e"],
  },
  {
    num: 4,
    pregunta: `¿Sabés cuál es el precio aproximado que tiene armar un almuerzo diario?`,
    respuesta: `true`,
    perfil: [`a`, "b", "d", "e", "f", "g", "h"],
  },
  {
    num: 5,
    pregunta: `¿Sos quien se ocupa habitualmente de cocinar en tu casa?`,
    respuesta: `true`,
    perfil: ["a", "b", "e", "d", "g", "h"],
  },
  {
    num: 6,
    pregunta: `Después de utilizar una taza o un vaso ¿lo dejás apoyado en la mesa o en la mesada para que alguien más lo lave?`,
    respuesta: `false`,
    perfil: [`a`, "b", "d", "e"],
  },
  {
    num: 7,
    pregunta: `¿Te ocupas de la higiene de tu habitación?`,
    respuesta: `true`,
    perfil: [`a`, "b", "d", "e"],
  },
  {
    num: 8,
    pregunta: `Si tenés  herman@s más pequeños, ¿sabés a qué cosas hay que estar atento cuando quedás a cargo de su cuidado? `,
    respuesta: `true`,
    perfil: [`a`, "b"],
  },
  {
    num: 9,
    pregunta: `En caso de tenerla, ¿te ocupas de las necesidades de tu mascota?`,
    respuesta: `true`,
    perfil: [`a`, "b", "d", "e"],
  },
  {
    num: 10,
    pregunta: `¿Te encargás vos de la limpieza de la casa?`,
    respuesta: `true`,
    perfil: [`a`, "b", "c", "d", "e", "f", "g", "h"],
  },
  {
    num: 11,
    pregunta: `El piso está muy sucio. Abrís la alacena de los productos de limpieza, ¿tenés que consultar a alguien más qué productos usar para limpiar?`,
    respuesta: `false`,
    perfil: ["b", "d", "e"],
  },
  {
    num: 12,
    pregunta: `El cesto de la ropa sucia está lleno, ¿sabés poner el lavarropas?`,
    respuesta: `true`,
    perfil: [`a`, "b", "d", "e"],
  },
  {
    num: 13,
    pregunta: `Sos la única persona de la casa que sabe lo que hace falta comprar en el supermercado`,
    respuesta: `true`,
    perfil: ["b", "d", "e", "f", "g", "h"],
  },
  {
    num: 14,
    pregunta: `Llegás al supermercado. Hay que comprar lácteos, productos de limpieza y de higiene personal. ¿Conocés las marcas que generalmente se usan en tu casa?`,
    respuesta: `true`,
    perfil: ["b", "d", "e", "f", "g", "h"],
  },
  {
    num: 15,
    pregunta: `Llega la factura de luz del mes. Si querés comparar con otros meses, ¿sabés dónde buscar la información?`,
    respuesta: `true`,
    perfil: ["d", "e"],
  },
  {
    num: 16,
    pregunta: `Si contratás una persona que limpia en tu casa, ¿vos te ocupás de darle indicaciones?`,
    respuesta: `true`,
    perfil: ["d", "e", "f", "g", "h"],
  },
  {
    num: 17,
    pregunta: `Se van de viaje, ¿te ocupás de los papeles, los trámites y otros preparativos?`,
    respuesta: `true`,
    perfil: ["e", "f", "g", "h"],
  },
  {
    num: 18,
    pregunta: `¿Sabés cuánto se gasta al mes en comida?`,
    respuesta: `true`,
    perfil: ["c", "d", "e", "f", "g"],
  },
  {
    num: 19,
    pregunta: `Hay que llevar a tu hij@ a vacunar, ¿sabés dónde está guardado el carnet de vacunación?`,
    respuesta: `true`,
    perfil: ["f", "g"],
  },
  {
    num: 20,
    pregunta: `Es domingo, hay que preparar la ropa para la escuela de acuerdo a las actividades del día siguiente, ¿necesitás que alguien te indique qué prendas corresponden?`,
    respuesta: `false`,
    perfil: ["f", "g"],
  },
  {
    num: 21,
    pregunta: `¿Ordenás la ropa de otros integrantes de la familia?`,
    respuesta: `true`,
    perfil: ["b", "e", "f", "g", "h"],
  },
  {
    num: 22,
    pregunta: `Tu hij@ tiene control pediátrico, ¿vos l@ llevás ?`,
    respuesta: `true`,
    perfil: ["f"],
  },
  {
    num: 23,
    pregunta: `Querés comprarle zapatillas a tu hij@ ¿Tenés que preguntarle a tu pareja cuánto calza?`,
    respuesta: `false`,
    perfil: ["f", "g"],
  },
  {
    num: 24,
    pregunta: `¿Estás en el chat de la escuela?`,
    respuesta: `true`,
    perfil: ["f"],
  },
  {
    num: 25,
    pregunta: `¿Sabés los nombres de los compañer@s de escuela de tu hij@?`,
    respuesta: `true`,
    perfil: ["f", "g"],
  },
  {
    num: 26,
    pregunta: `¿Dejás el celular con sonido alto cuando tu hij@ sale de noche por si te llama para algo?`,
    respuesta: `true`,
    perfil: ["g"],
  },
  {
    num: 27,
    pregunta: `¿Sabés qué alimentos consume tu hij@ todos los días?`,
    respuesta: `true`,
    perfil: ["f", "g"],
  },
  {
    num: 28,
    pregunta: `Tu hij@ te plantea que ya no se siente cómod@ yendo a su pediatra ¿le ayudás a buscar un profesional con quien se sienta a gusto?`,
    respuesta: `true`,
    perfil: ["g"],
  },
  {
    num: 29,
    pregunta: `¿Sos la persona encargada de pedir los turnos médicos para la persona adulta mayor a tu cuidado?`,
    respuesta: `true`,
    perfil: ["h"],
  },
  {
    num: 30,
    pregunta: `Es necesario realizar un trámite en el banco junto a la persona adulta mayor a tu cuidado, ¿pedís el día en tu trabajo para asistir a acompañarle?`,
    respuesta: `true`,
    perfil: ["h"],
  },
  {
    num: 31,
    pregunta: `Te vas de viaje, ¿podés hacerlo sin encargarte de resolver el cuidado de la persona adulta mayor que convive con vos?`,
    respuesta: `false`,
    perfil: ["h"],
  },
  {
    num: 32,
    pregunta: `Hay una reunión de familia en la escuela de tu hij@ ¿Sos quien asiste?`,
    respuesta: `true`,
    perfil: ["f"],
  },
  {
    num: 33,
    pregunta: `Tu hij@ se contagió de piojos, ¿sos la persona encargada de sacárselos?`,
    respuesta: `true`,
    perfil: ["f"],
  },
  {
    num: 34,
    pregunta: `Si hay una pérdida en una cañería de la casa, ¿te ocupás de llamar a profesionales que resuelvan el problema?`,
    respuesta: `true`,
    perfil: ["c", "d", "e", "f", "g", "h"],
  },
  {
    num: 35,
    pregunta: `¿Contás con que alguien más te recuerde cuando se aproximan las fechas de cumpleaños de amig@s o familiares?`,
    respuesta: `false`,
    perfil: ["c", "d", "e", "f", "g", "h"],
  },
  {
    num: 36,
    pregunta: `¿Ayudas a tu hij@ a realizar las tareas escolares?`,
    respuesta: `true`,
    perfil: ["f", "g"],
  },
  {
    num: 37,
    pregunta: `Cuando un integrante de la familia se enferma, ¿solés ser la persona encargada de cuidarl@?`,
    respuesta: `true`,
    perfil: ["b", "d", "e", "f", "g", "h"],
  },
  {
    num: 38,
    pregunta: `Llaman de la escuela porque tu hij@se siente mal, ¿sos quien sale del trabajo para retirarl@?`,
    respuesta: `true`,
    perfil: ["f", "g"],
  },
  {
    num: 39,
    pregunta: `¿Sabés cuánto es el gasto fijo aproximado en servicios de tu hogar?`,
    respuesta: `true`,
    perfil: ["b", "c", "d", "e", "f", "g", "h"],
  },
  {
    num: 40,
    pregunta: `¿Necesitás que alguien te recuerde que están por vencer los pagos de los servicios de tu hogar?`,
    respuesta: `false`,
    perfil: ["c", "d", "e", "f", "g"],
  },
  {
    num: 41,
    pregunta: `Querés empezar a hacer una actividad física o recreativa, ¿considerás las opciones teniendo en cuenta los horarios del resto de la familia?`,
    respuesta: `true`,
    perfil: ["f", "g", "h"],
  },
  {
    num: 42,
    pregunta: `¿Sos la persona encargada de comprar los regalos para cumpleaños de hij@s, amistades o familiares?`,
    respuesta: `true`,
    perfil: ["c", "d", "e", "f", "g", "h"],
  },
  {
    num: 43,
    pregunta: `Tenés que comprar ropa para tus hij@s, ¿necesitás consultar con otra persona los talles que usan?`,
    respuesta: `false`,
    perfil: ["f", "g"],
  },
  {
    num: 44,
    pregunta: `Cuando un familiar o amig@ viene a tu casa ¿suele colaborar con la limpieza o el orden?`,
    respuesta: `false`,
    perfil: ["c", "d", "e", "f"],
  },
  {
    num: 45,
    pregunta: `¿Tuviste que postergar o abandonar los estudios primarios, secundarios o superiores por tener que cuidar a una persona?`,
    respuesta: `true`,
    perfil: ["f", "g", "h"],
  },
  {
    num: 46,
    pregunta: `¿Sos la primera persona en levantarse y organizar la rutina del resto de los integrantes de tu hogar?`,
    respuesta: `true`,
    perfil: ["b", "e", "f", "g", "h"],
  },
  {
    num: 47,
    pregunta: `¿Seguís pendiente de las necesidades del resto de los integrantes de la familia aun cuando estás haciendo una actividad propia?`,
    respuesta: `true`,
    perfil: ["e", "f", "g", "h"],
  },
  {
    num: 48,
    pregunta: `¿Realizas varias tareas en simultáneo? (lavar la ropa, cocinar, ayudar en la tarea a hij@s)`,
    respuesta: `true`,
    perfil: ["f", "g"],
  },
  {
    num: 49,
    pregunta: `¿Sos la persona que generalmente limpia el baño en tu casa?`,
    respuesta: `true`,
    perfil: ["a", "b", "c", "d", "e", "f", "g", "h"],
  },
  {
    num: 50,
    pregunta: `Se van de viaje, ¿alguien más se ocupa de armar tu valija?`,
    respuesta: `false`,
    perfil: [`a`, "b", "e", "f", "g", "h"],
  },
  {
    num: 51,
    pregunta: `Si buscás entre los contactos agendados en tu celular, no encontrás el teléfono del pediatra de tu hij@`,
    respuesta: `false`,
    perfil: [`f`],
  },
  {
    num: 52,
    pregunta: `Nunca atendiste un llamado telefónico laboral mientras tenés a tu hij@ a upa`,
    respuesta: `false`,
    perfil: [`f`],
  },
  {
    num: 53,
    pregunta: `¿Sos la persona que habitualmente se encarga de llevar a tu hij@ a cumpleaños de amig@s los fines de semana?`,
    respuesta: `true`,
    perfil: [`f`],
  },
];

export const JuegoCerebroOpciones = [
  { op: "b", txt: "Con tu familia de origen" },
  { op: "c", txt: "Solo/a" },
  { op: "d", txt: "Con un amigo/a/s" },
  { op: "e", txt: "Con tu pareja" },
  { op: "f", txt: "Con hijos/as niños/as" },
  { op: "g", txt: "Con hijos/as adolescentes o jóvenes" },
  {
    op: "h",
    txt: "Con una persona adulta mayor que requiere atención",
  },
];

export const juegoCerebroMensajeFinal = [
  {
    option: "a",
    msjf: {
      menos50: {
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `Sostener cotidianamente las tareas de cuidado y mantenimiento de un hogar es un trabajo. Es importante que podamos distribuir esas tareas `,
      },
      mas50: {
        txt1: "Tareas del hogar compartidas = Familias más igualitarias",
        txt2: `La organización de las tareas del hogar es una responsabilidad 
        compartida por todas las personas que conviven.`,
      },
    },
  },
  {
    option: "b",
    msjf: {
      menos50: {
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `Sostener cotidianamente las tareas de cuidado y mantenimiento 
        de un hogar es un trabajo. Es importante que podamos distribuir esas 
        tareas entre todas las personas que lo habitamos. `,
      },
      mas50: {
        txt1: `Tareas del hogar compartidas = Familias más igualitarias`,
        txt2: `a organización de las tareas del hogar es una responsabilidad 
        compartida por todas las personas que conviven.`,
      },
    },
  },
  {
    option: "c",
    msjf: {
      menos50: {
        txtT: "Hay mucho espacio libre en tu cerebro… mirá a tu alrededor",
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `Sostener cotidianamente las tareas de cuidado y mantenimiento 
        de un hogar es un trabajo. Es importante visibilizar la importancia 
        de esas tareas y valorarlas como necesarias para la vida.`,
      },
      mas50: {
        txtT: "Tu cerebro está sobrecargado",
        txt1: `La experiencia de vivir sol@ te permite dimensionar la gran cantidad de tareas necesarias para sostener cotidianamente un hogar. Hacerlo lleva tiempo, dinero, energía física y mental`,
        txt2: `¡No lo pierdas de vista si algún día convivís con alguien más, para 
        poder distribuir estas tareas de modo igualitario!`,
      },
    },
  },
  {
    option: "d",
    msjf: {
      menos50: {
        txtT: "Hay mucho espacio libre en tu cerebro… mirá a tu alrededor",
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `Sostener cotidianamente las tareas de cuidado y mantenimiento 
        de un hogar es un trabajo. Es importante visibilizar la importancia 
        de esas tareas y distribuirla de modo equitativo con nuestr@s pares.`,
      },
      mas50: {
        txtT: "Tu cerebro está sobrecargado",
        txt1: `Las tareas del hogar compartidas de modo igualitario nos permiten 
        convivir mejor.`,
        txt2: `La organización de las tareas del hogar es una responsabilidad compartida`,
      },
    },
  },
  {
    option: "e",
    msjf: {
      menos50: {
        txtT: "Hay mucho espacio libre en tu cerebro… mirá a tu alrededor",
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `La carga mental es la energía que demanda la organización del hogar. Son tareas invisibilizadas y poco valoradas, que requieren poner a disposición tiempo, mente, cuerpo y dinero. 
        ¡Empezá por casa a construir una sociedad más igualitaria!`,
      },
      mas50: {
        txtT: "Tu cerebro está sobrecargado",
        txt1: `Tareas del hogar compartidas =
        Familias más igualitarias
        `,
        txt2: `La organización de las tareas del hogar es una responsabilidad compartida por todas las personas que conviven. Apostar a una distribución equitativa es avanzar hacia la igualdad.`,
      },
    },
  },
  {
    option: "f",
    msjf: {
      menos50: {
        txtT: "Hay mucho espacio libre en tu cerebro… mirá a tu alrededor",
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `La carga mental es la energía que demanda la organización del hogar. Son tareas invisibilizadas y poco valoradas, que requieren poner a disposición tiempo, mente, cuerpo y dinero.
        Cuando tenemos personas a nuestro cuidado, las tareas se multiplican y los esfuerzos se redoblan. 
        ¡Empezá por casa a construir una sociedad más igualitaria!`,
      },
      mas50: {
        txtT: "Tu cerebro está sobrecargado",
        txt1: "Tareas del hogar compartidas = Familias más igualitarias",
        txt2: `La organización de las tareas del hogar y el sostén de quienes necesitan cuidado es una responsabilidad compartida por todas las personas que conviven.
        Apostar a una distribución equitativa es avanzar hacia la igualdad.
        `,
      },
    },
  },
  {
    option: "g",
    msjf: {
      menos50: {
        txtT: "Hay mucho espacio libre en tu cerebro… mirá a tu alrededor",
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `La carga mental es la energía que demanda la organización del hogar. Son tareas invisibilizadas y poco valoradas, que requieren poner a disposición tiempo, mente, cuerpo y dinero.
        Cuando tenemos personas a nuestro cuidado, las tareas se multiplican y los esfuerzos se redoblan.
        ¡Empezá por casa a construir una sociedad más igualitaria!`,
      },
      mas50: {
        txtT: "Tu cerebro está sobrecargado",
        txt1: "Tareas del hogar compartidas = Familias más igualitarias",
        txt2: `La organización de las tareas del hogar y el sostén de quienes necesitan cuidado es una responsabilidad compartida por todas las personas que conviven.
        Apostar a una distribución equitativa es avanzar hacia la igualdad.`,
      },
    },
  },
  {
    option: "h",
    msjf: {
      menos50: {
        txtT: "Hay mucho espacio libre en tu cerebro… mirá a tu alrededor",
        txt1: "Las tareas que vos no haces, ¿Quién las hace por vos?",
        txt2: `La carga mental es la energía que demanda la organización del hogar. Son tareas invisibilizadas y poco valoradas, que requieren poner a disposición tiempo, mente, cuerpo y dinero.
        Cuando tenemos personas a nuestro cuidado, las tareas se multiplican y los esfuerzos se redoblan. 
        ¡Empezá por casa a construir una sociedad más igualitaria!`,
      },
      mas50: {
        txtT: "Tu cerebro está sobrecargado",
        txt1: "Tareas del hogar compartidas = Familias más igualitarias",
        txt2: `La organización de las tareas del hogar y el sostén de quienes necesitan cuidado es una responsabilidad compartida por todas las personas que conviven.
        Apostar a una distribución equitativa es avanzar hacia la igualdad.`,
      },
    },
  },
];

export const introGame2 = {
  title: `Cerebros Sobrecargados`,
  txt: `¿Cuánto espacio ocupan en tu cabeza las tareas del hogar y el cuidado de las
	personas ?
	Contesta por SÍ o por NO éste cuestionario y al final del mismo sabrás cuánto espacio tenés en tu cabeza para dedicarle a nuevos proyectos, sueños, ocio y disfrute del tiempo libre.
	`,
  txt2: ``,
};
